import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";

interface ProtectedRouteProps {
  children: ReactNode;
  requireAdmin?: boolean;
  requireFounder?: boolean;
}

export default function ProtectedRoute({ children, requireAdmin = false, requireFounder = false }: ProtectedRouteProps) {
  const { role, isFounder, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-[200px]">
        <div className="h-8 w-8 border-2 border-primary border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (requireFounder && !isFounder) {
    return <Navigate to="/" replace />;
  }
  if (requireAdmin && role !== "admin" && !isFounder) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
